import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/unfollowChecked.svg';

export const IconUnfollowChecked = createIconComponent(Icon);
